export enum ForecastLoaderKey {
  LIST_RECONCILIATIONS = 'forecast-list',
  GET_RECONCILIATION = 'forecast-get',
  CREATE_RECONCILIATION = 'forecast-create',
  UPLOAD_FILE = 'forecast-upload-file',
  UPDATE_RECONCILIATION_STATUS = 'forecast-update-status',
  UPLOAD_NEW_FILE_VERSION = 'forecast-upload-new-file-version',
  UPDATE_FILE_VERSION_STATUS = 'forecast-update-file-version-status',
}
